module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kouku-c911e4bb3a6268282a2c07123a3770c5.png";